const makeUniqueMessage = (array) => {
  return array?.reduce((unique, o) => {
    if (!unique.some((obj) => obj.id === o.id)) {
      unique.push(o);
    }
    return unique;
  }, []);
};

const makeUniqueConversation = (array) => {
  return array?.reduce((unique, o) => {
    if (
      !unique.some((obj) => obj.timestamp === o.timestamp || obj.id === o.id)
    ) {
      unique.push(o);
    }
    return unique;
  }, []);
};

export { makeUniqueMessage, makeUniqueConversation };
